/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

export default {
  "Switch language": "Přepnout jazyk",
  "Botanical garden of the Charles University Science Faculty":
    "Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy",
  "Visit us": "Navštivte nás",
  Events: "Akce",
  "Garden map": "Mapa zahrady",
  Expositions: "Expozice",
  Tours: "Prohlídky",
  Other: "Ostatní",
  Contacts: "Kontakty",
  Search: "Hledej",
  open: "otevřeno",
  closed: "zavřeno",
  "Today {open}": "Dnes {open}",
  "Search for...": "Hledat...",
  BGUK: "BZUK",
  "Today we're": "Dnes máme",
  "When we're open": "Kdy máme otevřeno",
  published: "zveřejnil"
};
